export default "__VITE_ASSET__Zy_zmZ17__"